var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharliLogoFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 675,
    height: 127,
    viewBox: "0 0 675 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9034 126.512C57.2871 126.512 48.4248 124.977 40.3166 121.907C32.4621 118.996 25.2576 114.567 19.114 108.872C13.0749 103.236 8.28131 96.3992 5.04116 88.8007C1.68039 81.0398 0 72.5249 0 63.256C0 53.987 1.68039 45.4693 5.04116 37.7028C8.28343 30.1079 13.0768 23.2742 19.114 17.6398C25.2587 11.9469 32.4629 7.51783 40.3166 4.60482C48.4248 1.53494 57.2871 0 66.9034 0C78.1436 0 88.1949 1.94021 97.0572 5.82063C105.76 9.58045 113.379 15.467 119.213 22.9394L97.3156 42.7482C93.3617 38.1194 89.0167 34.5891 84.2806 32.1575C79.4327 29.6982 74.0633 28.4442 68.6276 28.5016C63.9455 28.447 59.2946 29.2689 54.9148 30.9248C50.8782 32.4602 47.2291 34.8654 44.2267 37.9697C41.2038 41.1525 38.8424 44.9034 37.2792 49.0052C35.5434 53.5534 34.6811 58.3881 34.7374 63.256C34.6792 68.1295 35.5416 72.9701 37.2792 77.5237C38.8437 81.6195 41.2067 85.3635 44.2309 88.538C47.2328 91.642 50.8821 94.0459 54.919 95.5787C59.2969 97.237 63.9464 98.0617 68.6276 98.0103C74.0697 98.0738 79.4468 96.8226 84.3018 94.3629C89.0492 91.9285 93.3942 88.3361 97.3368 83.5858L119.234 103.399C113.389 110.882 105.776 116.794 97.0783 120.602C88.1991 124.539 78.1408 126.509 66.9034 126.512Z",
    fill: "url(#paint0_linear_31_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.606 85.8268L517.871 124.076H481.016L458.962 91.7534C458.962 91.7534 472.035 91.2492 476.33 90.5206C480.27 89.8555 489.175 87.0553 491.606 85.8268Z",
    fill: "url(#paint1_linear_31_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.583 124.076L308.282 2.43162H342.168L396.04 124.076H360.24L318.186 19.2877H331.742L289.689 124.076H254.583Z",
    fill: "url(#paint2_linear_31_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.907 23.3715C504.561 16.5935 498.334 11.4097 490.225 7.82015C482.117 4.23062 472.502 2.43444 461.381 2.43162H405.945V124.076H440.352V91.7534H461.381C472.502 91.7534 482.117 89.9868 490.225 86.4538C498.334 82.9207 504.561 77.8527 508.907 71.2498C513.254 64.6469 515.426 56.653 515.423 47.2683C515.423 38.118 513.251 30.1524 508.907 23.3715ZM475.441 60.4727C471.848 63.6019 466.461 65.1665 459.279 65.1665H440.339V29.5437H459.279C466.464 29.5437 471.851 31.1366 475.441 34.3223C479.03 37.5079 480.827 41.8233 480.829 47.2683C480.838 52.9449 479.046 57.3464 475.453 60.4727H475.441Z",
    fill: "url(#paint3_linear_31_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.537 124.076V2.43162H568.931V96.7945H626.798V124.076H534.537Z",
    fill: "url(#paint4_linear_31_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.524 124.076V2.43162H674.931V124.076H640.524Z",
    fill: "url(#paint5_linear_31_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 65.2682H163.524V2.43162H129.117V124.076H163.524V91.7491L244.678 91.7534V65.2682Z",
    fill: "url(#paint6_linear_31_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.271 124.076V2.43162H244.678V124.076H210.271Z",
    fill: "url(#paint7_linear_31_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.678 65.2682H210.271V91.7534H244.678V65.2682Z",
    fill: "#65CEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.289 65.2682L302.66 91.7491H350.344L339.617 65.2682H313.289Z",
    fill: "url(#paint8_linear_31_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.004 65.2682H336.644L347.268 91.7491H381.734L370.004 65.2682Z",
    fill: "#65CEF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_41",
    x1: 139.322,
    y1: 135.794,
    x2: 33.2759,
    y2: 29.7471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_41",
    x1: 511.648,
    y1: 130.286,
    x2: 466.036,
    y2: 84.6788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_41",
    x1: 377.617,
    y1: 142.5,
    x2: 272.917,
    y2: 37.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31_41",
    x1: 482.808,
    y1: 98.4679,
    x2: 396.358,
    y2: 12.0183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_31_41",
    x1: 619.69,
    y1: 131.202,
    x2: 512.728,
    y2: 24.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_31_41",
    x1: 734.179,
    y1: 139.687,
    x2: 557.815,
    y2: -36.6775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_31_41",
    x1: 214.33,
    y1: 122.106,
    x2: 111.888,
    y2: 19.6605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_31_41",
    x1: 303.91,
    y1: 139.687,
    x2: 127.546,
    y2: -36.6777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_31_41",
    x1: 362.091,
    y1: 119.463,
    x2: 310.591,
    y2: 67.9625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 675,
    height: 127,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharliLogoFull);
export default __webpack_public_path__ + "static/media/charli-logo-full.7afe46abe6c061e46f75846b1cc13204.svg";
export { ForwardRef as ReactComponent };